import React from 'react';
import { isEmpty } from 'lodash';
import { Select } from '@metarouter-private/mr-mui';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';

export default function PipelineSelect() {
  const {
    pipelineSelect: { options, loading, selectedPipelineId, onSelectPipeline },
  } = useTestPlaybookDrawerContext();

  const handleChange = event => {
    onSelectPipeline(event.target.value);
  };

  return (
    <Select
      label="Pipeline"
      variant="outlined"
      size="small"
      fullWidth
      options={options}
      value={selectedPipelineId ?? ''}
      onChange={handleChange}
      disabled={loading || isEmpty(options)}
      data-test-id="PipelineSelect"
    />
  );
}
